<template>
  <div>
    <canvas
      ref="mountNode"
      style="width: 100%; height: 250px;"
    ></canvas>
  </div>
</template>

<script>
import F2 from '@antv/f2';

export default {
  name: 'HistogramTransposedChart',
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    config: {
      xKey: 'title',
      yKey: 'value',
      color: '#B6CCFC',
      unit: '万',
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data() {
      this.refresh();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    refresh() {
      this.chart.clear();
      this.init();
    },
    init() {
      const { Global } = F2;
      const { data } = this;
      const {
        xKey,
        yKey,
        color,
        unit,
      } = this.config;

      const chart = new F2.Chart({
        el: this.$refs.mountNode,
        pixelRatio: window.devicePixelRatio,
        backgroundColor: '#ffffff',
        appendPadding: [10, 40, 10, 10],
      });
      this.chart = chart;

      let dataValue = data.map(it => it[yKey]);
      dataValue = [...new Set(dataValue)];

      chart.source(data, {
        [yKey]: {
          values: [Math.max.apply(null, dataValue)],
        },
      });
      chart.coord({
        transposed: true,
      });
      chart.tooltip(false);
      chart.axis(xKey, {
        // eslint-disable-next-line no-underscore-dangle
        line: Global._defaultAxis.line,
        grid: null,
        label: {
          textAlign: 'end',
          fill: '#333333',
        },
      });

      chart.axis(yKey, {
        // eslint-disable-next-line no-underscore-dangle
        line: Global._defaultAxis.line,
        // eslint-disable-next-line no-underscore-dangle
        grid: Global._defaultAxis.grid,
        label: function label(text, index, total) {
          const textCfg = {};
          if (index === 0) {
            textCfg.textAlign = 'left';
          } else if (index === total - 1) {
            textCfg.textAlign = 'right';
          }
          return textCfg;
        },
      });
      chart
        .interval()
        .position(`${xKey}*${yKey}`)
        .color(color)
        .size(10)
        .style({
          radius: [5],
        });

      // 绘制文本
      data.forEach((obj) => {
        chart.guide().text({
          position: [obj.title, obj.value],
          content: `${obj.value}${unit}`,
          style: {
            textAlign: 'start',
            fill: '#999999',
          },
          offsetX: 0,
          offsetY: -12,
        });
      });

      chart.guide().text({
        position: ['100%', '100%'],
        content: `${unit}元`,
        style: {
          textAlign: 'end',
          fill: '#999999',
        },
        offsetX: 30,
        offsetY: 12,
      });
      chart.render();
    },
  },
};
</script>
